<template>
    <BasePaymentRadioInput
        :selected-payment-method="selectedPaymentMethod"
        :numeric-value="2"
        name="transfer"
        :title-text="$t('form.bank-transfer-payment-method.title')"
        :subtitle-text="$t('form.bank-transfer-payment-method.subtitle')"
        :update-value="(value) => $emit('update-payment-method', value)"
    />
</template>

<script>
import BasePaymentRadioInput from './BasePaymentRadioInput.vue';
export default {
    name: 'BankTransferRadioInput',
    components: {
        BasePaymentRadioInput,
    },
    props: {
        selectedPaymentMethod: {
            type: Number,
            required: false,
            default: null,
        },
    },
};
</script>

<style scoped></style>
